import { Async } from "@lexriver/async"
import { TypeEvent, TypeEventResult } from "@lexriver/type-event"
import { BasketInLocalStorage } from "./Basket/BasketInLocalStorage"
import { BasketOnServer } from "./Basket/BasketOnServer"
import { IBasket } from "./Basket/IBasket"
import { GlobalUser } from "./GlobalUser"
import { JsonBasketStats } from "./json-data-types/JsonBasketStats"

export module GlobalBasket{

    //let isInitialized = false
    //TODO: when add product, send basket stats also!
    export const onBasketUpdateEvent = new TypeEvent<()=>TypeEventResult>()
    export const onBasketEmptyOrFullEvent = new TypeEvent<(isEmpty:boolean)=>TypeEventResult>()

    export const onBasketCouponChangeEvent = new TypeEvent<() => TypeEventResult>()

    export const onBasketStatsEvent = new TypeEvent<(basketStats:JsonBasketStats)=>TypeEventResult>()

    export let anonymousBasket = new BasketInLocalStorage()

    function initAnonymousBasket(){
        anonymousBasket.onChangeEvent.subscribe(async () => {
            console.log('@', 'BasketInLocalStorage on change')
            //DomeEventDispatcher.triggerEvent(EnumDomeEventDispatcherEvents.BasketUpdated)
            await onBasketUpdateEvent.triggerAsync()
        })
        anonymousBasket.onBasketEmptyOrNotEvent.subscribe(async (isEmpty:boolean) => {
            //console.log('@', 'BasketInLocalStorage on empty/not')
                                            
            //DomeEventDispatcher.triggerEvent(EnumDomeEventDispatcherEvents.BasketEmptyOrNot, {isEmpty})
            await onBasketEmptyOrFullEvent.triggerAsync(isEmpty)
        })
        anonymousBasket.onCouponChangeEvent.subscribe(async () => {
            await onBasketCouponChangeEvent.triggerAsync()
            await onBasketUpdateEvent.triggerAsync()
        })
        
    }

    export let loggedInUserBasket:BasketOnServer = new BasketOnServer()

    function initUserBasket(){
        loggedInUserBasket.onChangeEvent.subscribe(async () => {
            //DomeEventDispatcher.triggerEvent(EnumDomeEventDispatcherEvents.BasketUpdated)
            await onBasketUpdateEvent.triggerAsync()
        })
        loggedInUserBasket.onBasketEmptyOrNotEvent.subscribe(async (isEmpty:boolean) => {
            //DomeEventDispatcher.triggerEvent(EnumDomeEventDispatcherEvents.BasketEmptyOrNot, {isEmpty})
            await onBasketEmptyOrFullEvent.triggerAsync(isEmpty)
        })

        loggedInUserBasket.onCouponChangeEvent.subscribe(async () => {
            await onBasketCouponChangeEvent.triggerAsync()
            await onBasketUpdateEvent.triggerAsync()
        })
        
        loggedInUserBasket.onBasketStatsEvent.subscribe(async (params) => {
            await onBasketStatsEvent.triggerAsync(params)
        })
    }

    export async function getCurrentBasketAsync():Promise<IBasket>{
        if(await GlobalUser.checkIfLoggedInAsync()) {
            await Async.waitForFunctionToReturnTrueAsync(() => loggedInUserBasket.isInitialized(), 500, 100000)
            return loggedInUserBasket
        }
        return anonymousBasket
    }

    function reactOnLoginLogout(){
        GlobalUser.eventUserLoggedIn.subscribe(async () => {
            //loggedInUserBasket = new BasketOnServer()
            await onBasketUpdateEvent.triggerAsync()
        })
        GlobalUser.eventUserLoggedOut.subscribe(async () => {
            //anonymousBasket = new BasketInLocalStorage()
            await onBasketUpdateEvent.triggerAsync()
        })
        GlobalUser.loggedInUserO.eventOnChange.subscribe(async () => {
            await onBasketUpdateEvent.triggerAsync()
        })
    }


    function initAsync(){
        initAnonymousBasket()
        initUserBasket()
        reactOnLoginLogout()
    }

    initAsync()


}